import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Paginator from '../Paginator';
import Game from '../Game';
import PostPage from '../PostPage';
import Footer from '../Footer';
import ChapterContent from '../ChapterContent';
import ContentSection from '../ContentSection';
import ReactGA from '../ga';
import $ from 'jquery';
import './index.scss';


import 'fullpage.js/dist/jquery.fullpage.js';

let options = {
      sectionClassName: 'section',
    };

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentChapter: -1,
      currentSection: -1,
      allChapters: []
    }
  }

  resize = () => {
    if ($(window).width() < 1024) {

    }
  }

  componentDidMount() {
    this.initFullPage();
    $(document).ready(() => {
      $('body').click(() => {
        this.props.closeSidebar();
      })
    })

  }

  componentDidUpdate(prevProps) {
    if (prevProps.homepage !== this.props.homepage) {
      this.initFullPage();
    }
  }

  componentWillUnmount() {
    $.fn.fullpage.destroy('all');
  }

  initFullPage = () => {
    const that = this;
    $(document).ready(function() {
      if (that.props.homepage && that.props.homepage.chapters) {
        // const allChapters = that.props.homepage.chapters.map((c, i) => {
        //   return c.sections.map((s, j) => {
        //     return {
        //       name: s.title,
        //       number: `${i+1}.${j+1}`
        //     }
        //   })
        // })

        const allChapters = that.props.homepage.chapters.map((c, i) => {
          return {
            name: c.name,
            number: `0${i+1}`,
            sections: c.sections.unshift({
              subtitle: `${i+1}.0`,
              template: 'chapter-content',
              index: c.index,
              name: c.name,
              content: c.content,
            }),
          }
        });

        that.setState({
          allChapters: allChapters
        });

        $('#fullpage').fullpage({
          afterLoad: (anchorLink, index) => {
            var gameFrame = document.getElementById('game-iframe').contentWindow

            if (anchorLink === 'game') {
              gameFrame.postMessage('sound:resume', window.location.href);
            }
            else {
              gameFrame.postMessage('sound:pause', window.location.href);
            }
            if (anchorLink !== 'game' && anchorLink !== 'footer' && anchorLink !== 'postPage'){
              that.setState({
                currentChapter: anchorLink.toString().slice(0, 1),
                currentSection: anchorLink.toString().slice(2, 3)
              })
            }
            else {
              that.setState({
                currentChapter: 0,
                currentSection: 0
              })
            }
          },
          responsiveWidth: 600,
          normalScrollElements: '#game-iframe, textarea',
          verticalCentered: true,

          afterLoad: (index, nextIndex) => {
            ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);
            // console.log(`On leave: ${index}, to ${nextIndex}`);
          }
        });
      }
    });
  }

  render() {
    const { homepage } = this.props;
    return (
      <div className="homepage">
        <Paginator chapters={this.state.allChapters} sectionIndex={this.state.currentSection > 0 && this.state.currentSection} chapterIndex={this.state.currentChapter}/>
        {
          homepage.chapters &&
          homepage.chapters.length > 0 &&
          <div id="fullpage">
            <div className="section" data-anchor="game"><Game/></div>
            {
              homepage.chapters.map((chapter, i) => {
                return chapter.sections.map((section, j) => {
                  if (section.template === 'chapter-content') {
                    return (
                      <div className="section" data-anchor={section.subtitle}><ChapterContent {...section}/></div>
                    )
                  }
                  else {
                    return (
                      <div className="section" data-anchor={section.subtitle}><ContentSection {...section}/></div>
                    )
                  }

                })
              })
            }
            <div className="section -post" data-anchor="post-section"><PostPage intro={homepage.post_intro}/></div>
            <div className="section" data-anchor="footer"><Footer/></div>
          </div>
        }
      </div>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/components/Homepage/pure.js